export enum MicrositeButtonShape {
  SQUARE = 'SQUARE',
  ROUNDED = 'ROUNDED',
  CIRCULAR = 'CIRCULAR',
}
